export enum CookiePolicyEnum {
  Minimal = 'minimal',
  All = 'all',
}
